import React, { useEffect } from "react";


function Activity(props) {
  useEffect(() => {
    //TODO:
  });

  return (
    <React.Fragment>
      <h5>Development is in progress</h5>
    </React.Fragment>
  )
}

export default Activity;